export const Transition = {
    fast: '0.1s ease',
    hover: '0.25s ease',
    input: '0.26s ease',
    collapse: '0.4 ease',
}
